import { render } from "./CriteriaPage.vue?vue&type=template&id=2f00f92c&scoped=true&ts=true"
import script from "./CriteriaPage.vue?vue&type=script&lang=ts"
export * from "./CriteriaPage.vue?vue&type=script&lang=ts"

import "./CriteriaPage.vue?vue&type=style&index=0&id=2f00f92c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f00f92c"]])

export default __exports__